export const CREATED_AT_VALUE = "createdAt"
export const ASCEDING_ORDER_VALUE = "asc"
export const FIFO_VALUE = "firstInFirstOut"
